import { NAV_PATHS } from '@modules/common/constants';
import { WisdomLogoIcon } from '@modules/oracle/components/WisdomLogoIcon';
import { ReplayRounded } from '@mui/icons-material';
import { alpha, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function WisdomUnSavedChatToolbar() {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: 'sticky',
        height: '3.5rem',
        zIndex: 10,
        p: 2,
        mb: 2,
        top: 0,
        backgroundColor: (theme) =>
          alpha(theme.palette.background.default, 0.9),
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <WisdomLogoIcon sx={{ width: 32, height: 32 }} />
        <Typography
          variant="h6"
          sx={{
            background:
              'linear-gradient(106deg, #B206CE 30.9%, #7357F6 62.92%, #83A9F3 118.3%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Wisdom
        </Typography>
      </Stack>
      <Button
        size="small"
        color="primary"
        endIcon={<ReplayRounded />}
        onClick={() => {
          navigate(`/${NAV_PATHS.WISDOM}`);
        }}
      >
        Clear
      </Button>
    </Stack>
  );
}
